<h2 mat-dialog-title [ngClass]="titleClass" [style.fontSize]="'var(--tt-font-size-xl)'" cdkDrag cdkDragRootElement=".cdk-overlay-pane" cdkDragBoundary=".cdk-overlay-container" cdkDragHandle>
    <ng-container *ngIf="messages.length !== 1">
        <span ttTranslateWord="grid_messages"></span>
    </ng-container>
    <ng-container *ngIf="messages.length === 1">
        <span>
            {{ title }}
        </span>
    </ng-container>
</h2>
<mat-dialog-content class="grid-messages-modal__content">
    <section *ngFor="let message of messages; trackBy: trackByMessage" class="grid-messages-modal__message">
        <h3 *ngIf="shouldShowTitle(message)" class="grid-messages-modal__message-title">{{ message.title }}</h3>
        <p class="grid-messages-modal__message-text">{{ message.message }}</p>
        <a *ngIf="!!message.gototext && !!message.item_state" class="grid-messages-modal__link" [href]="getStatePath(message)" (click)="goto(message, $event)">{{ message.gototext }}</a>
    </section>
</mat-dialog-content>
<mat-dialog-actions align="end">
    <tt-button class="col-xs-3 sp-2" ttText="Ok" [ttType]="type" (ttClick)="dialogRef.close()"></tt-button>
</mat-dialog-actions>
